module.exports = __webpack_public_path__ + "img/rectangle_1218_copy_2.3461bf92.png";